import type { TWarehouseTaskStatus } from 'api/swagger';
import { ALLOWED_FLOW_STATUS } from './constants';

export const getAvailableStatuses = (currentStatus: TWarehouseTaskStatus): Record<TWarehouseTaskStatus, boolean> => {
  const permittedTransitions = ALLOWED_FLOW_STATUS[currentStatus];

  return {
    waiting: permittedTransitions.includes('waiting'),
    progress: permittedTransitions.includes('progress'),
    done: permittedTransitions.includes('done'),
    cancelled: permittedTransitions.includes('cancelled'),
  };
};
